<template>
  <div class="swiper">
    <swiper ref="mySwiper" :options="swiperOptions" :auto-play="true">
            <swiper-slide>
                <img src="../../images/1.jpg" alt=""/>
            </swiper-slide>
               <swiper-slide>
                <img src="../../images/1.jpg" alt=""/>
            </swiper-slide>
               <swiper-slide>
                <img src="../../images/1.jpg" alt=""/>
            </swiper-slide>
               <swiper-slide>
                <img src="../../images/1.jpg" alt=""/>
            </swiper-slide>
               <swiper-slide>
                <img src="../../images/1.jpg" alt=""/>
            </swiper-slide>
            <div class="swiper-button-prev"
             slot="button-prev"></div>
            <div class="swiper-button-next"
             slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  data () {
      return{
        swiperOptions: {
            grabCursor: true,
            autoplay: {
            delay: 2000,
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
            },
            loop: true,
            slidesPerView : 4,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        },
      }
   }
}
</script>

<style lang="less" scoped>
.swiper-button-next,.swiper-button-prev{
    width: 30px;
    height: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(218,218,218,0.5); 
    border-radius: 50%;
}

.swiper-button-next:after,.swiper-button-prev:after{
    font-size: 18px;
    color: #b3b3b3;
}
.swiper{
    img{
        width: 118px;
        height: 118px;
        opacity: 0.29;
        background: #0097ce;
        border-radius: 23px;
        margin-left: 50px;
    }
}
</style>